export const formatTry = (value) => {
  if (value === null || value === undefined) return '-';
  try {
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY',
      maximumFractionDigits: 2,
    }).format(Number(value));
  } catch {
    return `${value}`;
  }
};

export const formatMonth = (localDateLikeString) => {
  if (!localDateLikeString) return '-';
  const [y, m] = localDateLikeString.split('-');
  return `${y}-${m}`;
};

/**
 * Reads an amount the user typed: Turkish (`42.333,00`, `42333,5`) or plain
 * (`42333.00`). A comma is the decimal separator and dots are thousands;
 * without a comma a single dot is the decimal point. Returns a number, or
 * `null` unless it is non-zero, has at most two decimals and fits
 * numeric(12,2).
 */
export const parseAmountInput = (text) => {
  let s = String(text ?? '').replace(/\s|₺|TL/gi, '');
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  else if ((s.match(/\./g) || []).length > 1) s = s.replace(/\./g, '');
  if (!/^-?\d+(\.\d{1,2})?$/.test(s)) return null;
  const n = Number(s);
  if (n === 0 || Math.abs(n) >= 1e10) return null;
  return n;
};
